/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AuditLogEntryType {
    ViewReply = 'VIEW_REPLY',
    ListReply = 'LIST_REPLY',
    ModifyReply = 'MODIFY_REPLY',
    DeleteReply = 'DELETE_REPLY',
    CreateReply = 'CREATE_REPLY',
    ViewReplyAttachment = 'VIEW_REPLY_ATTACHMENT',
    DownloadReplyAttachment = 'DOWNLOAD_REPLY_ATTACHMENT',
    ExportReplyPdf = 'EXPORT_REPLY_PDF',
    ExportReplyXlsx = 'EXPORT_REPLY_XLSX'
}

export function AuditLogEntryTypeFromJSON(json: any): AuditLogEntryType {
    return AuditLogEntryTypeFromJSONTyped(json, false);
}

export function AuditLogEntryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogEntryType {
    return json as AuditLogEntryType;
}

export function AuditLogEntryTypeToJSON(value?: AuditLogEntryType | null): any {
    return value as any;
}

